import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { BaseService } from './base.service';
import { Configuration } from './configuration';
import { AuthService } from './auth.service';
import {LocalStorageService, SessionStorageService} from 'ngx-webstorage';
@Injectable()
export class CallService extends BaseService {

	constructor(http: Http, test : AuthService,localStorageService:LocalStorageService) {
    	super(http,localStorageService);
    	test.isAuthenticated();
	}
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/nostra-mufit-info-prod/workspace/src/app/services/base-services/call.service.ts